





















import { Component, Prop, Provide, Vue } from 'vue-property-decorator'
import TaskQuerySource from '../modules/TaskQuerySource.vue'
import TaskQueryInProcess from '../modules/TaskQueryInProcess.vue'
import TaskQueryCompleted from '../modules/TaskQueryCompleted.vue'
import TaskQueryDeleted from '../modules/TaskQueryDeleted.vue'

import { option, column } from '../interface/'

import { USER_GROUPS } from '../../../service/constant'
import { ALL_GROUPS } from '../config/'

@Component({
  components: {
    TaskQuerySource,
    TaskQueryInProcess,
    TaskQueryCompleted,
    TaskQueryDeleted
  }
})
export default class TaskQuery extends Vue {
  private get groups() {
    return this.$store.state[USER_GROUPS]
  }
  activeKey = '1'
  isSourceTabVisibale = true
  created() {
    this.renderTabs()
  }
  renderTabs() {
    if (!this.groups.includes(ALL_GROUPS[3].id)) {
      this.isSourceTabVisibale = false
      this.activeKey = '2'
    }
  }
  mounted() {
    const query = this.$route.query
    if (query.tab) {
      this.activeKey = String(query.tab)
    }
  }
}
